import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-teaser',
  templateUrl: './teaser.component.html'
})
export class TeaserComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() {
  }

}
